import { getValidYesNo } from './transportPdfCommonUtils';

export const planApprovedNote1 = `*Transport Outcome Code Legend:`;
export const planApprovedNote2 = `1. Placed/Completed, 2. No-show, 3. Walked Away, 4 Proveder/Family Transported, 5. Declined Ride, 6, Cancelled, 7 Was Not Released, 8. Denied by Provider, 9. Transferred, 10 Released Early.`;
export const outcomeTitle = `*Outcome Code (see Legend below):`;

export const getFirstRowData = ({ source, trnHiCon, specialTransport }) => [
  {
    title: 'Special Transport Needs',
    value: getValidYesNo(specialTransport),
  },
  { title: 'High Control Parolee', value: getValidYesNo(trnHiCon) },
  { title: 'Source', value: source },
];

export const getContactsFirstData = ({
  fundingSTOPBilltoOrganizationName,
  departingSAPorJailDepartureLocationName,
  toOrg, toContact
}) => [
  { xs: 3, title: 'Funding STOP', value: fundingSTOPBilltoOrganizationName },
  {
    xs: 3,
    title: 'Departing SAP',
    value: departingSAPorJailDepartureLocationName,
  },
  { xs: 3, title: 'Community Provider Facility', value: toOrg },
  { xs: 3, title: 'Person Recieving at Destination', value: toContact },
];

export const getContactsSecondData = ({ fundingSTOPContact, fromContact }) => [
  { xs: 3, title: 'Funding Stop Contact', value: fundingSTOPContact },
  { xs: 3, title: 'SAP Transition Counselor', value: fromContact },
  { xs: 3, title: 'Community Provider Address', value: '' },
  { xs: 3, title: 'Title', value: '' },
];

export const getPhoneFaxData = () => [
  { value: 'Phone' },
  { value: 'Fax' },
  { value: 'Phone' },
  { value: 'Fax' },
  { value: 'Phone' },
  { value: 'Fax' },
  { value: 'Phone' },
  { value: 'Fax' },
];

export const getApprovedCheckbox = ({ approved }) => [
  {
    label: '1. Approved',
    checked: approved,
  },
];

export const getFailedToAppearCheckbox = ({ failedToAppear }) => [
  {
    label: '2. Failed to Appear',
    checked: failedToAppear,
  },
];

export const getParticipantInfo = ({
  prtKey,
  epdIcnCDC,
  departingSAPorJailDepartureLocationName,
  firstData,
  trnCmt,
}) => [
  { xs: 3, title: 'Participant Name', value: prtKey },
  { xs: 3, title: 'CDC Number', value: epdIcnCDC },
  {
    xs: 3,
    title: 'Departing Institution',
    value: departingSAPorJailDepartureLocationName,
  },
  { xs: 3, title: firstData },
  { xs: 3, title: 'Comments', value: trnCmt },
];

export const getContactsData = ({
  contactsFirstData,
  secondData,
  getPhoneFaxData,
}) => [
  { xs: 4, title: contactsFirstData },
  { xs: 4, title: secondData },
  { xs: 4, title: getPhoneFaxData() },
];

export const getScheduleData = ({ departureDate }) => [
  { xs: 3, title: 'Initial Departure Date', value: departureDate },
  { xs: 3, title: 'Name of SAP Staff Confirming Release', value: '' },
  { xs: 3, title: 'Date', value: '' },
  { xs: 3, title: 'Phone Number of SAP Staff', value: '' },
];

export const getPlanCompletedData = () => [
  { xs: 3, title: 'Who Contacted', value: '' },
  { xs: 3, title: 'Contacted By', value: '' },
  { xs: 3, title: 'Date', value: '' },
  { xs: 3, title: 'Time', value: '' },
];

export const getPlanApprovedData = ({ getTrnDateCreate }) => [
  { xs: 6, title: 'STOP Representative: ', value: '' },
  { xs: 6, title: 'Date', value: getTrnDateCreate },
  { xs: 6, title: 'Email Approved', value: '' },
  { xs: 6, title: 'Date', value: '' },
];

export const getStaffTimeRow = ({ trnQtyTMEst, trnQtyTMAct }) => [
  { value: 'Staff Time' },
  { value: '$00.00 each hour' },
  { value: trnQtyTMEst },
  { value: '1/4 hours =' },
  { value: 0 },
  { value: 'Staff Time' },
  { value: '$00.00 each hour' },
  { value: trnQtyTMAct },
  { value: '1/4 hours =' },
  { value: '$00.00' },
];

export const getMileageRow = ({ trnQtyMlgEst, trnQtyMlgAct }) => [
  { value: 'Mileage' },
  { value: '$00.00 per mile' },
  { value: trnQtyMlgEst },
  { value: 'miles =' },
  { value: 0 },
  { value: 'Mileage' },
  { value: '$00.00 per mile' },
  { value: trnQtyMlgAct },
  { value: 'miles =' },
  { value: '$00.00' },
];

export const getOvertimeRow = ({ trnQtyTMOTAct }) => [
  { value: 'Overtime' },
  { value: '$00.00 each hour' },
  { value: 0 },
  { value: '1/4 hours =' },
  { value: 0 },
  { value: 'Overtime' },
  { value: '$00.00 each hour' },
  { value: trnQtyTMOTAct },
  { value: '1/4 hours =' },
  { value: '$00.00' },
];
